<script>
	import "mini.css/dist/mini-default.min.css"

	export let Records = [];
	export let Title = "";
	const keys = Records.length == 0 ? [] : Object.keys(Records[0]);
</script>

<main>
	<table class="striped full-height">
		<caption>{Title} ({Records.length})</caption>
		<thead>
			<tr>
				{#each keys as key}
					<th>{key}</th>
				{/each}
			</tr>
		</thead>
		<tbody>
			{#each Records as Record}
				<tr>
					{#each keys as key}
						<td>{Record[key]}</td>
					{/each}
				</tr>
			{/each}
		</tbody>
	</table>
</main>

<style>
.full-height {
	max-height: none !important;
}
</style>
